import { storageApi } from '../../apiInstances'
import { IPlant, IPlantEdit, IPlantPost } from '../../../types/plant'
import { IStorageSystem, IStorageSystemPost } from '../../../types/storageSystem'
import { IScenario, IScenarioPost } from '../../../types/scenario'
import { IResultDetail } from '../../../types/results'

export default {
  fetchPlants(): Promise<IPlant[]> {
    return storageApi.get('/plant/retrieve')
  },
  createPlant(plant: IPlantPost) {
    return storageApi.post('/plant/save', plant)
  },
  editPlant(plantId: string, plant: IPlantEdit) {
    return storageApi.put(`/plant/${plantId}`, plant)
  },
  deletePlant(plantId: string) {
    return storageApi.delete(`/plant/${plantId}`)
  },

  fetchStorageSystems(): Promise<IStorageSystem[]> {
    return storageApi.get('/storage_system/retrieve')
  },
  createStorageSystems(storageSystem: IStorageSystemPost) {
    return storageApi.post('/storage_system/save', storageSystem, {})
  },
  editStorageSystem(storageSystemId: string, storageSystem: IStorageSystem) {
    return storageApi.put(`/storage_system/${storageSystemId}`, storageSystem, {})
  },
  deleteStorageSystem(storageSystemId: string) {
    return storageApi.delete(`/storage_system/${storageSystemId}`)
  },

  fetchScenarios(): Promise<IScenario[]> {
    return storageApi.get('/scenario/retrieve')
  },
  createScenario(scenario: IScenarioPost) {
    return storageApi.post('/scenario/save', scenario)
  },
  editScenario(scenarioId: string, scenario: IScenario) {
    return storageApi.put(`/scenario/${scenarioId}`, scenario)
  },
  deleteScenario(scenarioId: string) {
    return storageApi.delete(`/scenario/${scenarioId}`)
  },

  fetchResults(): Promise<IResultDetail[]> {
    return storageApi.get(`/result/retrieve`)
  },
  fetchResult(resultId: string): Promise<IResultDetail> {
    return storageApi.get(`/result/${resultId}`)
  },
  deleteResult(resultId: string) {
    return storageApi.delete(`/result/${resultId}`)
  },
}
